"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorCommentaryMaybe = exports.getEndPeriodCommentary = exports.getPeriodStartCommentary = exports.getAdjustScoreCommentary = exports.getDeactivatePlayerCommentary = exports.getActivatePlayerCommentary = exports.getPlayCommentary = void 0;
var tslib_1 = require("tslib");
var definitions_1 = require("./events/definitions");
var helper = tslib_1.__importStar(require("../common/template_helpers"));
var math_1 = require("../common/math");
var underscore_1 = tslib_1.__importDefault(require("underscore"));
var announcements_1 = require("./announcements");
var stats_1 = require("./stats");
var announcements_2 = require("../multi_sport_common/announcements");
function getPlayCommentary(playCode, playerOrTeamId, selector) {
    if (selector === void 0) { selector = math_1.getRandomInt; }
    var credit = helper.stubbify(playerOrTeamId);
    switch (playCode) {
        case definitions_1.PlayCode.Made2: {
            return handleMade2(credit, selector);
        }
        case definitions_1.PlayCode.Made3: {
            return handleMade3(credit, selector);
        }
        case definitions_1.PlayCode.Missed2: {
            return handleMissed2(credit, selector);
        }
        case definitions_1.PlayCode.Missed3: {
            return handleMissed3(credit, selector);
        }
        case definitions_1.PlayCode.MadeFreeThrow: {
            return handleMadeFreeThrow(credit, selector);
        }
        case definitions_1.PlayCode.MissedFreeThrow: {
            return handleMissedFreeThrow(credit, selector);
        }
        case definitions_1.PlayCode.Foul: {
            return handleFoul(credit, selector);
        }
        case definitions_1.PlayCode.Turnover: {
            return handleTurnover(credit, selector);
        }
        case definitions_1.PlayCode.Rebound:
        case definitions_1.PlayCode.DefensiveRebound:
        case definitions_1.PlayCode.OffensiveRebound: {
            return handleRebound(credit, selector);
        }
        case definitions_1.PlayCode.Assist: {
            return handleAssist(credit, selector);
        }
        case definitions_1.PlayCode.Steal: {
            return handleSteal(credit, selector);
        }
        case definitions_1.PlayCode.Block: {
            return handleBlock(credit, selector);
        }
        case definitions_1.PlayCode.Timeout: {
            return handleTimeout(credit);
        }
        case definitions_1.PlayCode.Timeout30: {
            return handleTimeout30(credit);
        }
        default: {
            return undefined;
        }
    }
}
exports.getPlayCommentary = getPlayCommentary;
function handleMade2(credit, selector) {
    var made2Commentary = [
        "".concat(credit, " finishes with the soft touch for 2"),
        "Easy shot from ".concat(credit, " for 2"),
        "".concat(credit, " puts it up and in for 2"),
        "".concat(credit, " nails the deuce"),
        "".concat(credit, " with the soft touch around the rim for 2"),
    ];
    var selectedIndex = selector(made2Commentary.length);
    return made2Commentary[selectedIndex];
}
function handleMade3(credit, selector) {
    var made3Commentary = [
        "The shot from ".concat(credit, " is good for 3"),
        "".concat(credit, " drains one from beyond the arc"),
        "".concat(credit, " knocks down the trifecta!"),
        "".concat(credit, " with the triple"),
        "".concat(credit, " with the 3 is good"),
    ];
    var selectedIndex = selector(made3Commentary.length);
    return made3Commentary[selectedIndex];
}
function handleMissed2(credit, selector) {
    var missed2Commentary = [
        "No good for 2 from ".concat(credit, " that time"),
        "".concat(credit, " is too strong on the 2 and misses"),
        "Just off the mark with that one from ".concat(credit, " for 2"),
        "Tough luck on the close-range shot from ".concat(credit),
        "".concat(credit, " Nearly had it for 2, but the ball spins out"),
    ];
    var selectedIndex = selector(missed2Commentary.length);
    return missed2Commentary[selectedIndex];
}
function handleMissed3(credit, selector) {
    var missed3Commentary = [
        "".concat(credit, " is off from 3"),
        "No basket on the triple from ".concat(credit),
        "A long one from ".concat(credit, " is missed"),
        "".concat(credit, " not good from long range"),
        "".concat(credit, " came up short on the 3 point attempt"),
    ];
    var selectedIndex = selector(missed3Commentary.length);
    return missed3Commentary[selectedIndex];
}
function handleMadeFreeThrow(credit, selector) {
    var madeFreeThrowCommentary = [
        "".concat(credit, " Sinks the free throw!"),
        "".concat(credit, " Calmly drains the free throw"),
        "".concat(credit, " Delivers a perfect stroke from the free throw line"),
    ];
    var selectedIndex = selector(madeFreeThrowCommentary.length);
    return madeFreeThrowCommentary[selectedIndex];
}
function handleMissedFreeThrow(credit, selector) {
    var missedFreeThrowCommentary = [
        "".concat(credit, " Comes up short from the free throw line"),
        "No luck from ".concat(credit, "'s free throw shot"),
        "".concat(credit, " Can't find the mark from the free throw line"),
    ];
    var selectedIndex = selector(missedFreeThrowCommentary.length);
    return missedFreeThrowCommentary[selectedIndex];
}
function handleFoul(credit, selector) {
    var foulCommentary = ["".concat(credit, " Commits the foul on that play"), "Oops, that\u2019s a foul by ".concat(credit)];
    var selectedIndex = selector(foulCommentary.length);
    return foulCommentary[selectedIndex];
}
function handleTurnover(credit, selector) {
    var turnoverCommentary = ["".concat(credit, " Loses possession with the turnover"), "".concat(credit, " Turns it over")];
    var selectedIndex = selector(turnoverCommentary.length);
    return turnoverCommentary[selectedIndex];
}
function handleRebound(credit, selector) {
    var reboundCommentary = [
        "".concat(credit, " Grabs the board"),
        "".concat(credit, " Cleans the glass with that rebound"),
        "".concat(credit, " Claims the board"),
    ];
    var selectedIndex = selector(reboundCommentary.length);
    return reboundCommentary[selectedIndex];
}
function handleAssist(credit, selector) {
    var assistCommentary = [
        "".concat(credit, " with the dish"),
        "".concat(credit, " Delivers the dime"),
        "".concat(credit, " Makes it look easy with the assist"),
    ];
    var selectedIndex = selector(assistCommentary.length);
    return assistCommentary[selectedIndex];
}
function handleSteal(credit, selector) {
    var stealCommentary = [
        "".concat(credit, " Is picking pockets with the steal"),
        "".concat(credit, " Forces the turnover with the steal"),
        "".concat(credit, " Sneaks up and steals the ball away"),
    ];
    var selectedIndex = selector(stealCommentary.length);
    return stealCommentary[selectedIndex];
}
function handleBlock(credit, selector) {
    var blockCommentary = [
        "".concat(credit, " Rejects the shot with the block"),
        "".concat(credit, " Swats it away"),
        "".concat(credit, " Sends it back with the block"),
    ];
    var selectedIndex = selector(blockCommentary.length);
    return blockCommentary[selectedIndex];
}
function handleTimeout(credit) {
    return "A minute timeout is called by ".concat(credit);
}
function handleTimeout30(credit) {
    return "A quick timeout on the floor by ".concat(credit);
}
function getActivatePlayerCommentary(playerId, selector) {
    if (selector === void 0) { selector = math_1.getRandomInt; }
    var playerIdTemplate = helper.stubbify(playerId);
    var playerActivationCommentary = [
        "".concat(playerIdTemplate, " Checks in"),
        "".concat(playerIdTemplate, " Enters the game"),
        "".concat(playerIdTemplate, " Makes their way onto the court"),
    ];
    var selectedIndex = selector(playerActivationCommentary.length);
    return playerActivationCommentary[selectedIndex];
}
exports.getActivatePlayerCommentary = getActivatePlayerCommentary;
function getDeactivatePlayerCommentary(playerId, selector) {
    if (selector === void 0) { selector = math_1.getRandomInt; }
    var playerIdTemplate = helper.stubbify(playerId);
    var playerDeactivationCommentary = [
        "".concat(playerIdTemplate, " Is headed to the bench after a strong stint"),
        "".concat(playerIdTemplate, " Takes a breather on the bench"),
        "Substitution time! ".concat(playerIdTemplate, " makes way for a sub"),
    ];
    var selectedIndex = selector(playerDeactivationCommentary.length);
    return playerDeactivationCommentary[selectedIndex];
}
exports.getDeactivatePlayerCommentary = getDeactivatePlayerCommentary;
function getAdjustScoreCommentary(awayScore, homeScore) {
    return "Score changed! ".concat(awayScore, " ").concat(homeScore);
}
exports.getAdjustScoreCommentary = getAdjustScoreCommentary;
function getPeriodStartCommentary(awayId, homeId, awayScore, homeScore, period) {
    var awayIdTemplate = helper.stubbify(awayId);
    var homeIdTemplate = helper.stubbify(homeId);
    var periodFormatted = (0, announcements_2.formatPeriod)(period);
    // Game Intro Commentary
    if (period === 1) {
        return (0, announcements_1.generateGameState)(awayId, homeId, awayScore, homeScore, period);
    }
    return "The ".concat(periodFormatted, " is underway. ").concat(awayIdTemplate, " take on ").concat(homeIdTemplate, ". The current score is ").concat(awayIdTemplate, " ").concat(awayScore, " ").concat(homeIdTemplate, " ").concat(homeScore);
}
exports.getPeriodStartCommentary = getPeriodStartCommentary;
function getEndPeriodCommentary(period, scoreState) {
    var periodFormatted = (0, announcements_2.formatPeriod)(period);
    var scores = underscore_1.default.sortBy((0, announcements_1.prepareScore)({
        scores: scoreState.scores,
        homeTeamId: scoreState.homeId,
        awayTeamId: scoreState.awayId,
    }), function (t) { return -1 * t.score; });
    var winningDiff = scores[0].score - scores[1].score;
    return winningDiff === 0
        ? "The ".concat(periodFormatted, " ends tied up at ").concat(scores[0].score)
        : "The ".concat(periodFormatted, " comes to a close with ").concat(scores[0].stub, " leading the game by ").concat(winningDiff);
}
exports.getEndPeriodCommentary = getEndPeriodCommentary;
function getColorCommentaryMaybe(stats, playByPlayState, playCode, playerId, teamId) {
    var colorCommentaryArray = [];
    var heatingUpMaybe = getHeatingUpMaybe(playByPlayState, playCode, teamId);
    if (heatingUpMaybe) {
        colorCommentaryArray.push(heatingUpMaybe);
    }
    var tenPointCallout = getTenPointCalloutMaybe(stats, playCode, playerId, teamId);
    if (tenPointCallout) {
        colorCommentaryArray.push(tenPointCallout);
    }
    if (colorCommentaryArray.length === 0) {
        return undefined;
    }
    return colorCommentaryArray.join(' ').trim();
}
exports.getColorCommentaryMaybe = getColorCommentaryMaybe;
function getTenPointCalloutMaybe(stats, playCode, playerId, teamId) {
    if (![definitions_1.PlayCode.Made2, definitions_1.PlayCode.Made3, definitions_1.PlayCode.MadeFreeThrow].includes(playCode)) {
        return undefined;
    }
    try {
        var sumOfPointsByPlayer = +stats.stats[teamId].players[playerId].stats['offense'][stats_1.HoopsStat.PTS];
        switch (playCode) {
            case definitions_1.PlayCode.MadeFreeThrow:
                if (sumOfPointsByPlayer === 10) {
                    return "They now have 10 points in the game!";
                }
                break;
            case definitions_1.PlayCode.Made2:
                if ([10, 11].includes(sumOfPointsByPlayer)) {
                    return "They now have ".concat(sumOfPointsByPlayer, " points in the game!");
                }
                break;
            case definitions_1.PlayCode.Made3:
                if ([10, 11, 12].includes(sumOfPointsByPlayer)) {
                    return "They now have ".concat(sumOfPointsByPlayer, " points in the game!");
                }
                break;
            default:
                return undefined;
        }
    }
    catch (e) {
        return undefined;
    }
}
function getHeatingUpMaybe(playByPlayState, playCode, teamId) {
    if (![definitions_1.PlayCode.Made2, definitions_1.PlayCode.Made3].includes(playCode)) {
        return undefined;
    }
    try {
        var streakCount = playByPlayState.latestScorerStreaks[teamId].streakCount;
        switch (streakCount) {
            case 2:
                return 'That’s back to back buckets, they’re heating up!';
            case 3:
                return 'That’s 3 buckets in a row, they’re on fire!';
            default:
                return undefined;
        }
    }
    catch (e) {
        return undefined;
    }
}
//# sourceMappingURL=play_by_play_commentary.js.map